/** Lo mínimo de `Crypto` que hace falta; inyectable para probar el respaldo. */
export type IdempotencyCrypto = Pick<Crypto, 'getRandomValues'> & { randomUUID?: () => string };

/**
 * `Idempotency-Key` para una operación de dinero: un UUID v4 (36 caracteres,
 * muy por debajo del tope de 255 del contrato).
 *
 * Se genera UNO NUEVO por cada pulsación del usuario — un doble clic o un
 * reintento dentro de la misma petición los absorbe el back con la misma llave;
 * una pulsación nueva es una intención nueva.
 *
 * Sin `crypto.randomUUID` (contextos no seguros o navegadores viejos) se arma
 * el v4 a mano con `getRandomValues`: nunca con `Math.random`, que no es un
 * generador criptográfico y puede repetir.
 */
export function newIdempotencyKey(cryptoImpl: IdempotencyCrypto = globalThis.crypto): string {
  if (typeof cryptoImpl.randomUUID === 'function') {
    return cryptoImpl.randomUUID();
  }
  const bytes = cryptoImpl.getRandomValues(new Uint8Array(16));
  // RFC 4122 §4.4: versión 4 y variante 10xx.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
